var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"facebook-share"),React.createElement("path",{"fill":"#1976d2","d":"M28 0h-24c-2.207 0-4 1.793-4 4v24c0 2.205 1.793 4 4 4h24c2.205 0 4-1.795 4-4v-24c0-2.207-1.795-4-4-4z","key":1}),React.createElement("path",{"fill":"#fafafa","d":"M27 16h-5v-4c0-1.104 0.896-1 2-1h2v-5h-4c-3.315 0-6 2.685-6 6v4h-4v5h4v11h6v-11h3l2-5z","key":2})]);
}

Facebook.defaultProps = {"version":"1.1","width":"16","height":"16","viewBox":"0 0 32 32"};

module.exports = Facebook;

Facebook.default = Facebook;
